import {DMS_OAUTH_FLOW_COOKIE_NAME} from './DMS_OAUTH_FLOW_COOKIE_NAME';

const HTTPS_PROTOCOL = 'https:';

export const setOAuthFlowCookie = (value: string, domain: string, maxAge: number) => {
  const domainAttribute = domain.length > 0 ? `; Domain=${domain}` : '';
  const secureAttribute = window.location.protocol === HTTPS_PROTOCOL ? '; Secure' : '';
  document.cookie = `${DMS_OAUTH_FLOW_COOKIE_NAME}=${value}; Max-Age=${maxAge}; Path=/; SameSite=Lax${domainAttribute}${secureAttribute}`;
};
